import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    seeMore: 'See more',
    submitOperation: 'Dispute {count} operation',
    submitOperations: 'Dispute {count} operations',
    subtitle: 'Select from transactions eligible for dispute.',
    title: 'Dispute transactions',
  },
  fr: {
    seeMore: 'Voir plus',
    submitOperation: 'Contester {count} opération',
    submitOperations: 'Contester {count} opérations',
    subtitle:
      'Sélectionnez parmi les transactions éligibles à la contestation.',
    title: 'Contester des opérations',
  },
} as const);

export default locales;
